"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});var e=(r=>(r.Existing="EXISTING",r.New="NEW",r.Winner="WINNER",r))(e||{});exports.ExperimentAssignmentType=e;
